<!--
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-11 15:40:48
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-03-12 17:50:31
 * @FilePath: \hzs-nutra-wecom-shop\src\views\live\liveDetail\index.vue
 * @Description: 直播详情
-->

<template>
  <div class="page-container" :class="state.activeName === 'a' ? 'short' : ''">
    <div class="mainContent">
      <van-tabs v-model:active="state.activeName">
        <van-tab title="直播详情" name="a"></van-tab>
        <van-tab title="明细数据" name="b"></van-tab>
      </van-tabs>

      <div class="componentBox">
        <liveDetailInfo
          v-if="state.activeName == 'a'"
          :activity="state.activity"
          :liveId="liveId"
        ></liveDetailInfo>
        <liveDetailData
          v-if="state.activeName == 'b'"
          :activity="state.activity"
          :liveId="liveId"
        ></liveDetailData>
      </div>
    </div>

    <div v-if="state.activeName === 'a'" class="bottom_button_box">
      <van-button
        round
        block
        type="primary"
        class="save-btn"
        color="#DCBB89"
        @click="handleData(4)"
      >
        查看门店企微好友
      </van-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import liveDetailData from "./components/liveDetailData.vue";
import liveDetailInfo from "./components/liveDetailInfo.vue";

// --------------------------------------- 变量
const router = useRouter();
const route = useRoute();

/**
 * type: 1-小程序客户 2-企微好友
 */
const liveId = ref(route.query.id);

const state = reactive({
  activeName: "a",
  activity: {},
});
// --------------------------------------- 方法、事件
onMounted(() => ({}));

// --------------------------------------- 请求
</script>

<style lang="scss" scoped>
/* @use 'xxx.scss' as *; */
/*
    .page-container
        ---- 主体内容
        .mainContent

        ---- 底部操作栏
        .bottom_button_box
    @supports

    **** 在 @/scss/common.scss ****
*/

.page-container {
  padding-bottom: 0;

  &.short {
    padding-bottom: 80px;
  }

  .mainContent {
    padding: 0;
    overflow: hidden;

    .icon {
      width: 28px;
      height: 28px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;

      &.wechatIcon {
        background-image: url("@/assets/img/icons/wechat-ico.png");
      }
      &.weComIcon {
        background-image: url("@/assets/img/icons/wecom-ico.png");
      }
      &.telephoneIcon {
        background-image: url("@/assets/img/icons/phoneicon-1.png");
      }
    }

    .van-tabs {
      height: 52px;

      :deep(.van-tabs__wrap) {
        height: 100% !important;

        .van-tab__text {
          height: 22px;
          font-family:
            PingFang SC,
            PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #999999;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
        .van-tab--active .van-tab__text {
          font-weight: 600;
          font-size: 16px;
          color: #333333;
        }

        .van-tabs__line {
          background: #dcbb89;
        }
      }
    }

    .componentBox {
      height: calc(100% - 52px);
      overflow-y: scroll;
      padding: 10px 18px;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}

// 适配底部栏在iPhone上的位置
@supports (padding-bottom: env(safe-area-inset-bottom)) {
  .page-container {
    padding-bottom: 0;

    &.short {
      padding-bottom: calc(10px + env(safe-area-inset-bottom) + 10px + 44px);
    }

    .bottom-bar {
      padding-bottom: calc(10px + env(safe-area-inset-bottom));
    }
  }
}
</style>
